import { installApplicationInsights } from "@wisr/common";

import { attachStore } from "./src/attach-store";
import { getConfig } from "./src/shared/config.utils";

installApplicationInsights({
  instrumentationKey: getConfig().APP_INSIGHTS_INSTRUMENTATION_KEY,
});

export const wrapRootElement = attachStore;
